import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "/" },
  { label: "赛事直播", href: "/category/saishizhibo" },
  { label: "运动课程", href: "/category/yundongkecheng" },
  { label: "健身计划", href: "/category/jianshenjihua" },
  { label: "体育资讯", href: "/category/tiyuzixun" },
  { label: "关于我们", href: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0">
          <span className={`text-2xl font-bold transition-colors duration-300 ${
            scrolled || !isHome ? "text-primary-500" : "text-white"
          }`}>
            <i className="ri-basketball-line w-7 h-7 inline-flex items-center justify-center"></i>
            云体育
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? "text-primary-500 bg-primary-100/70"
                  : scrolled || !isHome
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                    : "text-white/90 hover:text-white hover:bg-white/10"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap ${
              scrolled || !isHome
                ? "bg-primary-500 text-white hover:bg-primary-600"
                : "bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm"
            }`}
          >
            加入云体育
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled || !isHome ? "text-foreground-700" : "text-white"
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? "text-primary-500 bg-primary-100/70"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 px-5 py-3 rounded-full text-sm font-semibold bg-primary-500 text-white text-center hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              加入云体育
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}